(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var elements = document.querySelectorAll('[data-campaign-countdown]');

    elements.forEach(function (el) {
      var targetStr = el.getAttribute('data-countdown-target');
      if (!targetStr) return;
      var target = new Date(targetStr + 'T00:00:00').getTime();

      var daysEl = el.querySelector('[data-cd-days]');
      var hoursEl = el.querySelector('[data-cd-hours]');
      var minEl = el.querySelector('[data-cd-min]');
      var secEl = el.querySelector('[data-cd-sec]');

      function pad(n) {
        return ('0' + n).slice(-2);
      }

      function update() {
        var now = new Date().getTime();
        var diff = target - now;
        if (diff <= 0) {
          el.hidden = true;
          return;
        }
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var secs = Math.floor((diff % (1000 * 60)) / 1000);
        daysEl.textContent = days;
        hoursEl.textContent = pad(hours);
        minEl.textContent = pad(mins);
        secEl.textContent = pad(secs);
      }

      update();
      setInterval(update, 1000);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var links = document.querySelectorAll('[data-hero-scroll]');
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  });
})();
